import * as React from "react"

export default function AddCircleOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.333 7.333V4.667h1.334v2.666h2.667v1.334H8.667v2.666H7.334V8.667H4.667V7.333h2.667zM8 14.667A6.667 6.667 0 118 1.333a6.667 6.667 0 010 13.334zm0-1.334A5.334 5.334 0 108 2.666a5.334 5.334 0 000 10.667z"
        fill={props.fill}
      />
    </svg>
  )
}
